import { useEffect, useState } from 'react';
import * as deviceDetect from 'react-device-detect';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { URL } from '@/constants';

const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN, APP_IOS_CN, APP_IOS_RU } = URL;
const IOS_LINK: any = {
    us: APP_IOS,
    cis: APP_IOS_RU,
    cn: APP_IOS_CN,
};
const loginMap: any = {
    eu: 'https://portal.ecoflow.com/pro/eu/en/login',
    nl: 'https://portal.ecoflow.com/pro/eu/en/login',
    uk: 'https://portal.ecoflow.com/pro/eu/en/login',
    de: 'https://portal.ecoflow.com/pro/eu/de/login',
};

export default function EcoFlowProAppH5({ lang }: any) {
    const { Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isIOS, setIsIOS] = useState<boolean>(false);

    const getAppDataLayer = (type: string) => {
        return {
            event: 'uaEvent',
            event_name: 'ecoflow_app',
            button_name: type,
        };
    };

    useEffect(() => {
        setIsIOS(deviceDetect.isIOS);
    }, []);

    return (
        <div className={`ecoFlow-pro-app-h5 ${css.EcoFlowProAppH5}`}>
            <div className="down-wrapper">
                <p className="sub-title">{lang.pro_app_subtitle}</p>
                <p className="title">{lang.pro_app_title}</p>
                <p className="desc">{lang.pro_app_desc}</p>
                {isIOS && (
                    <div className="apple-store store">
                        <Link href={IOS_LINK[locale] || IOS_LINK.us} dataLayer={getAppDataLayer('App Store')}>
                            <NextImage
                                webpSrc={require('@publicLocal/power-ocean/app/h5/apple-store.png')}
                                src={require('@publicLocal/power-ocean/app/h5/apple-store.png')}
                                alt={lang.pro_app_ios}
                                aria-label={lang.pro_app_ios}
                            />
                        </Link>
                        <p className="text">{lang.pro_app_ios}</p>
                    </div>
                )}
                {!isIOS && (
                    <div className="google-play store">
                        <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                            <NextImage
                                webpSrc={require('@publicLocal/power-ocean/app/h5/google-play.png')}
                                src={require('@publicLocal/power-ocean/app/h5/google-play.png')}
                                alt={lang.pro_app_apk}
                                aria-label={lang.pro_app_apk}
                            />
                        </Link>
                        <p className="text">{lang.pro_app_apk}</p>
                    </div>
                )}
                <Link
                    className="btn"
                    href={loginMap[locale]}
                    ariaLabel={lang.pro_app_login}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'select_product',
                        product_name: 'EcoFlow PowerOcean',
                        list_name: lang.pro_app_login,
                        button_name: lang.pro_app_login,
                    }}
                >
                    {lang.pro_app_login}
                    <EFAppArrow className="arrow-icon" width="12px" height="12px" />
                </Link>
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/h5/9-1.webp')}
                    src={require('@publicLocal/power-ocean/app/h5/9-1.png')}
                    alt={lang.pro_app_title}
                    aria-label={lang.pro_app_title}
                />
                <p className="tips">
                    {lang.pro_app_download1}
                    <Link href={locale === 'cn' ? APK_CN : APK_OVERSEAS} selfWin dataLayer={getAppDataLayer('Download the EcoFlow App apk file')}>
                        <span className="blue">{lang.pro_app_download2}</span>
                    </Link>
                </p>
            </div>
        </div>
    );
}

export async function getServerSideProps() {
    return {
        props: {},
    };
}
